var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettingsIconShow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.999,
    height: 12,
    viewBox: "0 0 17.999 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-9-9.5a3.467,3.467,0,0,0-.976.156A1.731,1.731,0,0,1-9.75-8.5,1.751,1.751,0,0,1-11.5-6.75a1.731,1.731,0,0,1-.844-.226,3.488,3.488,0,0,0-.136.968A3.493,3.493,0,0,0-8.989-2.518,3.493,3.493,0,0,0-5.5-6.009,3.493,3.493,0,0,0-8.989-9.5ZM-.109-6.456A10.023,10.023,0,0,0-9-12a10.025,10.025,0,0,0-8.891,5.544A1.006,1.006,0,0,0-18-6a1.014,1.014,0,0,0,.108.457A10.023,10.023,0,0,0-9,0,10.025,10.025,0,0,0-.109-5.544,1.006,1.006,0,0,0,0-6,1.014,1.014,0,0,0-.109-6.456ZM-9-1.5A8.5,8.5,0,0,1-16.435-6,8.5,8.5,0,0,1-9-10.5,8.5,8.5,0,0,1-1.565-6,8.5,8.5,0,0,1-9-1.5Z",
    transform: "translate(17.999 12)",
    fill: "#3a3630"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsIconShow);
export default __webpack_public_path__ + "static/media/settingsIcon_Show.5c03fdf8.svg";
export { ForwardRef as ReactComponent };